export const LOCALES = {
  es: 'es',
  en: 'en',
  pt: 'pt',
  ro: 'ro',
};
